import React from 'react';
import Slider from 'react-slick';
import { Col, Row, Container } from 'react-bootstrap/esm';
import HeaderOne from '../../components/header/HeaderOne';
import Footer from '../../components/footer/Footer';
import Breadcrumb from '../../components/teams/Breadcrumb';
import {
  getAllTeams,
  getMemberTokenId,
  isLeader,
} from '../../web3/SFM-TeamsUtils';
import TeamSingle from '../../components/teams/TeamSingle';
import { useAccount } from 'wagmi';
import PromptLogin from '../PromptLogin';
import { getMyTeam } from '../../web3/SFM-TeamsUtils';
import TeamSingleView from '../../components/teams/TeamSingleView';
import { getImageUrlFromJson } from '../../utils/getImageUrlFromJson';
import { PrevArrow } from '../../components/slider/prevArrow';
import { NextArrow } from '../../components/slider/nextArrow';
import Loader from '../../components/Loader/loader';
import { useTeam } from '../../contexts/TeamContext';

function Teams() {
  const { isConnected, address } = useAccount();
  const { setIsTeamchanged, isTeamchanged } = useTeam();
  const [addClicked, setAddClicked] = React.useState(false);
  const [allTeams, setAllTeams] = React.useState();
  const [myTeam, setMyTeam] = React.useState();
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    nav: true,
    autoplay: false,
    arrows: true,
    autoplaySpeed: 3000,

    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    slidesToShow:
      allTeams &&
      myTeam &&
      allTeams.filter(({ id }) => parseInt(myTeam.id) !== parseInt(id)).length >
        0 &&
      allTeams.filter(({ id }) => parseInt(myTeam.id) !== parseInt(id))
        .length <= 3
        ? allTeams.filter(({ id }) => parseInt(myTeam.id) !== parseInt(id))
            .length
        : 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          Padding: '100px 50px',
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const getTeams = React.useCallback(async () => {
    const teams = await getAllTeams();
    const leaderFlag = await isLeader(address);
    const data = [];
    if (teams) {
      for (const team of teams) {
        let leaderurl = await getImageUrlFromJson(team.leaderURI);
        let memberurl = await getImageUrlFromJson(team.memberURI);
        let contractAddress = process.env.REACT_APP_SFM_MEMBER_CONTRACT_ADRESS;
        data.push({
          ...team,
          leaderImage: leaderurl,
          memberImage: memberurl,
          tokenId: parseInt(team.memberTokenId),
          contractAddress: contractAddress,
          isLeader: leaderFlag,
        });
      }
      setAllTeams(data);
    }
    console.log(data);
  }, [isConnected, address]);

  const getUserTeam = React.useCallback(async () => {
    try {
      const team = await getMyTeam();
      if (team) {
        let leaderurl = await getImageUrlFromJson(team.leaderURI);
        let memberurl = await getImageUrlFromJson(team.memberURI);
        let contractAddress =
          address === team.leader
            ? process.env.REACT_APP_SFM_TEAM_CONTRACT_ADRESS
            : process.env.REACT_APP_SFM_MEMBER_CONTRACT_ADRESS;
        setMyTeam({
          ...team,
          leaderImage: leaderurl,
          memberImage: memberurl,
          tokenId: team.id.toString(), //assumption: tokenId in teams contract == team.id
          contractAddress,
        });
      }
    } catch (e) {
      setMyTeam({});
    }
  }, [isConnected, address]);

  React.useEffect(() => {
    if (isConnected) {
      try {
        getUserTeam();
        getTeams();
      } catch (err) {}
    }
  }, [getUserTeam, getTeams]);

  const modifyUpdatesState = async () => {
    setIsTeamchanged(!isTeamchanged);
    setAllTeams();
    setMyTeam();
    setAddClicked(false);
    await getTeams();
    await getUserTeam();
  };

  return (
    <>
      <HeaderOne />
      <main>
        <Breadcrumb mainTitle={'Teams Story'} subTitle={'Teams Story'} />
        <div className="team-wrapper">
          <Container>
            {isConnected ? (
              <>
                <Row className="pt-5 mb-3">
                  <Col lg={8} md={9} sm={12}>
                    <button
                      type="button"
                      className="btn btn-success"
                      name="submit"
                      onClick={() => setAddClicked(true)}
                      disabled={myTeam && Object.keys(myTeam).length !== 0}
                    >
                      Add New Team
                    </button>
                  </Col>
                </Row>
                {myTeam && Object.keys(myTeam).length !== 0 && (
                  <h6>You Are Already in a team and can't create new one</h6>
                )}
                {addClicked && (
                  <Row className="mb-5 d-flex justify-content-center">
                    <Col lg={8} md={9} sm={12}>
                      <TeamSingle
                        item=""
                        isAdd={true}
                        CallAddUpdateCanceled={() => {
                          setAddClicked(false);
                        }}
                        callSaveSucceed={() => modifyUpdatesState()}
                      />
                    </Col>
                  </Row>
                )}
                <h3 className="text-light">My Team</h3>
                {myTeam ? (
                  Object.keys(myTeam).length !== 0 ? (
                    <Row>
                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        className="d-flex jusitfy-content-center"
                      >
                        <TeamSingleView
                          item={myTeam}
                          isAdd={false}
                          CallAddUpdateCanceled={() => setAddClicked(false)}
                          callSaveSucceed={() => modifyUpdatesState()}
                          isMyTeam={true}
                          hasTeam={Object.keys(myTeam).length !== 0}
                        />
                      </Col>
                    </Row>
                  ) : (
                    <h4 className="text-center text-light">No Team Yet</h4>
                  )
                ) : (
                  <>
                    <div className="row justify-content-center ">
                      <h4>Fetching team Please wait...</h4>
                    </div>
                    <div className="row justify-content-center ">
                      <Loader />
                    </div>
                  </>
                )}
                <h3 className="text-light mt-5">All Teams</h3>
                {allTeams ? (
                  myTeam &&
                  allTeams.filter(
                    ({ id }) => parseInt(myTeam.id) != parseInt(id)
                  ).length > 0 ? (
                    <Slider
                      className="latest-games-active slick pb-5"
                      {...settings}
                    >
                      {allTeams
                        .filter(({ id }) => parseInt(myTeam.id) != parseInt(id))
                        .map((item, index) => (
                          <div key={index}>
                            <TeamSingleView
                              item={item}
                              isAdd={false}
                              CallAddUpdateCanceled={() => setAddClicked(false)}
                              callSaveSucceed={() => modifyUpdatesState()}
                              hasTeam={Object.keys(myTeam).length !== 0}
                            />
                          </div>
                        ))}{' '}
                    </Slider>
                  ) : (
                    <h4 className="text-center  text-light pb-100 mt-5 mb-0">
                      No Teams Yet
                    </h4>
                  )
                ) : (
                  <>
                    <div className="row justify-content-center">
                      <h4>Fetching teams Please wait...</h4>
                    </div>
                    <div className="row justify-content-center pb-5">
                      <Loader />
                    </div>
                  </>
                )}
              </>
            ) : (
              <PromptLogin />
            )}
          </Container>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default Teams;
